import { render, staticRenderFns } from "./TrazabilidadTest.vue?vue&type=template&id=1fe8a4e2"
import script from "./TrazabilidadTest.vue?vue&type=script&lang=js"
export * from "./TrazabilidadTest.vue?vue&type=script&lang=js"
import style0 from "./TrazabilidadTest.vue?vue&type=style&index=0&id=1fe8a4e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports